module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"photos":"Fotos","documents":"Dokumente"},"fr":{"documents":"Documents","photos":"Photos"},"it":{"documents":"Documenti","photos":"Foto"}}')
  delete Component.options._Ctor
}
